
  (function(){
    if(window.__ssTzBeacon)return;window.__ssTzBeacon=1;
    try{
      var tz=(Intl.DateTimeFormat().resolvedOptions()||{}).timeZone;
      if(!tz)return;
      var k='ss_tz_sent',prev=null;
      try{prev=JSON.parse(localStorage.getItem(k)||'null')}catch(e){}
      if(prev&&prev.tz===tz&&Date.now()-prev.at<86400000)return;
      fetch('/api/users/me/tz',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({tz:tz})})
        .then(function(r){if(r.status===200){try{localStorage.setItem(k,JSON.stringify({tz:tz,at:Date.now()}))}catch(e){}}})
        .catch(function(){});
    }catch(e){}
  })();
  